module.exports = __webpack_public_path__ + "img/map-pin.d74390fe.svg";